module.exports = __webpack_public_path__ + "static/media/image2.790d98fc.webp";